import { ForgotPassword } from '../../../components/ForgotPassword';
import { asModalComponent } from '../../../components/Modal';

const ForgotPasswordModalBase = ({ initialEmailAddress }: { initialEmailAddress?: string; [key: string]: unknown }) => {
	return <ForgotPassword hideLogo={true} initialEmailAddress={initialEmailAddress} />;
};

export const ForgotPasswordModal = asModalComponent(ForgotPasswordModalBase, {
	useDefaultHeader: true,
});
